function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessageWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Client Chat Message Waiting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Client-Chat-Message-Waiting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2620\\uFE0F-Icons-/tools-/chat---ON",
    fill: "#448E1B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C17.5228475,2 22,5.80557963 22,10.5 C22,15.1944204 17.5228475,19 12,19 C11.8068887,19 11.615056,18.9953472 11.4246484,18.9861664 C10.349765,20.7596898 7.8776655,22 5,22 C3.87407519,22 2.90379802,21.6600956 2.84341494,21.2267657 C2.77812215,20.6910014 3.81269859,20.315146 4.65676851,19.4099918 C5.25368237,18.7698801 5.74109525,18.0789561 6.1145586,17.3711828 C3.62004902,15.82612 2,13.3238727 2,10.5 C2,5.80557963 6.4771525,2 12,2 Z M12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 Z M7,8 C5.8954305,8 5,8.8954305 5,10 C5,11.1045695 5.8954305,12 7,12 C8.1045695,12 9,11.1045695 9,10 C9,8.8954305 8.1045695,8 7,8 Z M17,8 C15.8954305,8 15,8.8954305 15,10 C15,11.1045695 15.8954305,12 17,12 C18.1045695,12 19,11.1045695 19,10 C19,8.8954305 18.1045695,8 17,8 Z",
    id: "\\uDBC0\\uDF24",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessageWaiting);
export default __webpack_public_path__ + "static/media/chat_message_waiting.3c7360249c5da63ed4e80b9623c44080.svg";
export { ForwardRef as ReactComponent };